import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  template: `
    <footer class="ds-footer">
      <div class="container">
        <div class="ds-footer__top">
          <div class="ds-footer__brand">
            <img src="assets/images/keyo-logo.jpeg" alt="Keyo AI" height="32" class="ds-footer__logo">
            <p>
              Keyo AI, e-ticaret sitelerine özel geliştirilmiş yapay zeka destekli müşteri hizmetleri çözümü sunar.
              Sesli ve yazılı asistan teknolojimiz ile müşterilerinize 7/24 destek sağlayın.
            </p>
            <div class="ds-footer__social">
              <a href="https://tr.linkedin.com/company/keyo-digital" target="_blank" aria-label="LinkedIn"><i class="fab fa-linkedin"></i></a>
              <a href="https://x.com/keyodigital" target="_blank" aria-label="X"><i class="fab fa-x-twitter"></i></a>
              <a href="https://www.instagram.com/keyodigital/" target="_blank" aria-label="Instagram"><i class="fab fa-instagram"></i></a>
              <a href="https://www.facebook.com/keyodigital/" target="_blank" aria-label="Facebook"><i class="fab fa-facebook"></i></a>
              <a href="https://youtube.com/@keyodigital" target="_blank" aria-label="YouTube"><i class="fab fa-youtube"></i></a>
            </div>
          </div>

          <div class="ds-footer__col">
            <h5>Şirket</h5>
            <ul>
              <li><a routerLink="/about">Hakkımızda</a></li>
              <li><a routerLink="/customers">Müşterilerimiz</a></li>
              <li><a routerLink="/contact">İletişim</a></li>
              <!-- <li><a href="#">Kariyer</a></li> -->
            </ul>
          </div>

          <div class="ds-footer__col">
            <h5>Ürün</h5>
            <ul>
              <li><a routerLink="/how-it-works">Nasıl Çalışır</a></li>
              <li><a routerLink="/packages">Paketler</a></li>
          <!--   <li><a href="#">API Dokümantasyon</a></li>
              <li><a href="#">Entegrasyonlar</a></li> -->
            </ul>
          </div>
<!--
          <div class="ds-footer__col">
            <h5>Kaynaklar</h5>
            <ul>
              <li><a href="#">Blog</a></li>
              <li><a href="#">Başarı Hikayeleri</a></li>
              <li><a href="#">E-kitaplar</a></li>
              <li><a href="#">Webinarlar</a></li>
            </ul>
          </div> -->

          <div class="ds-footer__col">
            <h5>Yasal</h5>
            <ul>
              <li><a routerLink="/aydinlatma-metni">Aydınlatma Metni</a></li>
              <li><a routerLink="/cerez-bilgilendirme-metni">Çerez Bilgilendirme Metni</a></li>
              <li><a routerLink="/acik-riza-metni">Açık Rıza Metni</a></li>
            </ul>
          </div>
        </div>

        <div class="ds-footer__bottom">
          <p>&copy; {{currentYear}} Keyo AI. Tüm hakları saklıdır.</p>
       <!--   <img src="assets/images/payment-methods.png" alt="Ödeme Yöntemleri" height="24"> -->  
        </div>
      </div>
    </footer>
  `,
  styles: [`
    .ds-footer {
      background: var(--ds-bg-soft);
      padding: 80px 0 32px;
      border-top: 1px solid var(--ds-border);
    }
    @media (max-width: 768px) {
      .ds-footer { padding: 56px 0 24px; }
    }

    .ds-footer__top {
      display: grid;
      /* Marka + 3 bağlantı sütunu. Yasal sütunundaki etiketler uzun
         olduğu için o sütuna biraz daha genişlik verilir. */
      grid-template-columns: 2fr 1fr 1fr 1.4fr;
      gap: 48px;
    }
    @media (max-width: 992px) {
      .ds-footer__top {
        grid-template-columns: 1fr 1fr;
        gap: 32px;
      }
    }
    @media (max-width: 480px) {
      .ds-footer__top {
        grid-template-columns: 1fr;
      }
    }

    .ds-footer__brand p {
      color: var(--ds-text);
      font-size: 14px;
      line-height: 1.6;
      margin: 16px 0 20px;
      max-width: 420px;
    }
    .ds-footer__logo { display: block; margin-bottom: 4px; }

    .ds-footer__social {
      display: flex;
      gap: 10px;
    }
    .ds-footer__social a {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      border-radius: 10px;
      background: var(--ds-bg);
      color: var(--ds-text);
      font-size: 0.95rem;
      transition: background var(--ds-motion-base), color var(--ds-motion-base), transform var(--ds-motion-base);
      border: 1px solid var(--ds-border);
    }
    .ds-footer__social a:hover {
      background: var(--ds-cobalt);
      color: #fff;
      border-color: var(--ds-cobalt);
      transform: translateY(-1px);
    }

    .ds-footer__col h5 {
      font-size: 14px;
      font-weight: 600;
      color: var(--ds-text-display);
      margin: 0 0 16px;
      letter-spacing: 0.02em;
      text-transform: uppercase;
    }
    .ds-footer__col ul {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    .ds-footer__col a {
      color: var(--ds-text);
      font-size: 14px;
      text-decoration: none;
      transition: color var(--ds-motion-base);
    }
    .ds-footer__col a:hover {
      color: var(--ds-cobalt);
    }

    .ds-footer__bottom {
      border-top: 1px solid var(--ds-border);
      margin-top: 48px;
      padding-top: 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
      flex-wrap: wrap;
    }
    .ds-footer__bottom p {
      margin: 0;
      color: var(--ds-text-muted);
      font-size: 13px;
    }
  `]
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
}
